export const enum EmailErrorCode {
  InvalidEmail = 'invalid_email',
  InvalidDomain = 'invalid_domain',
  RejectedEmail = 'rejected_email',
  InvalidSMTP = 'invalid_smtp',
  NoConnect = 'no_connect',
  Timeout = 'timeout',
  UnavailableSMTP = 'unavailable_smtp',
  UnexpectedError = 'unexpected_error',
  AcceptedEmail = 'accepted_email',
  LowQuality = 'low_quality',
  LowDeliverability = 'low_deliverability',
  UserWithEmailExists = 'USER_WITH_EMAIL_EXISTS',
}

export const enum EmailError {
  InvalidEmail = 'h24_validation_error_form_emailAddress_pattern',
  RequestTryAgain = 'h24_newsletter_try_again',
  UserWithEmailExists = 'h24_validation_error_email_user_with_email_exists',
}
